import { useFormik } from 'formik'
import { FC } from 'react'
import { Button, FormInput, FormTextArea, useModal } from '../../../../../../components'
import { ButtonType, showError } from '../../../../../../../_metronic/helpers'
import { orientacoesSchema } from '../../validation/orientacoesSchema'
import { CustomOption } from '../../core/_model'

type IProps = {
  onConfirm: (item: CustomOption) => void
  orientacoes?: string
  titulo?: string
}

export const OrientacaoModal: FC<IProps> = ({ onConfirm, orientacoes, titulo }) => {
  const { closeModal } = useModal()

  const initialValues = {
    orientacoes: orientacoes || '',
    titulo: titulo || '',
  }

  const formik = useFormik({
    initialValues,
    validationSchema: orientacoesSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        const data: CustomOption = {
          label: values.titulo,
          descricao: values.orientacoes,
          value: null,
        }
        onConfirm(data)
        closeModal()
      } catch (error) {
        showError(error)
      } finally {
        setSubmitting(false)
      }
    },
  })

  return (
    <form onSubmit={formik.handleSubmit} noValidate>
      <FormInput
        formik={formik}
        name='titulo'
        placeholder='Digite o título da orientação'
        label='Título da Orientação'
        isRequired
        className='mb-3'
      />
      <FormTextArea
        formik={formik}
        name='orientacoes'
        placeholder='Digite as orientações'
        label='Orientações médicas'
        isRequired
        className='mb-3'
      />

      <div className='d-flex justify-content-end mt-5'>
        <Button type={ButtonType.Submit} className='btn-primary'>
          Criar
        </Button>
      </div>
    </form>
  )
}
